import api from './api';
import types from './mutation-types';
import moment from 'moment';

export default {
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAMS, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setResultMaster_({ commit }, { key, value }) {
		commit(types.RESULT_MASTER, { key, value });
	},
	setSelectedRows_({ commit }, rows) {
		commit(types.SELECTED_ROWS, rows);
	},
	getPowTourRgstManagements_({ commit, state }) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { searchParams } = state;

		return api
			.getPowTourRgstManagements({ searchParams: searchParams })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터값은뭐냐>>>>>', data.body.resultVo);

					commit(types.DEFAULT_ASSIGN, {
						key: 'resultMaster',
						value: data?.body.resultVo || {}
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'resultList',
						value: data?.body.resultList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'fileList',
						value: data?.body.fileList || []
					});
					commit(types.SEARCH_PARAMS, {
						key: 'ipnNos',
						value: data.body.resultVo.newIpnNos !== null ? data.body.resultVo.newIpnNos : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPowTourRgstManagement_({ commit }, { formData }) {
		//alert("액션")
		return api
			.postPowTourRgstManagement({ formData })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('저장 이후 >>>>>', data.body);
					commit(types.SEARCH_PARAMS, {
						key: 'insnDd',
						value: data.body.newInsnDd !== null && data.body.newInsnDd !== undefined ? data.body.newInsnDd : null
					});
					commit(types.SEARCH_PARAMS, {
						key: 'ipnNos',
						value: data.body.newIpnNos !== null && data.body.newIpnNos !== undefined ? data.body.newIpnNos : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPowTourRgstDelete_({ commit }, { formData }) {
		//alert("액션")
		return api
			.postPowTourRgstDelete({ formData })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SEARCH_PARAMS, {
						key: 'insnDd',
						value: moment().format('YYYYMMDD')
					});
					commit(types.SEARCH_PARAMS, {
						key: 'ipnNos',
						value: '1000'
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}, //실제 파일명을 클릭했을때 다운로드 하기 위한 함수
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload({ params });
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error.header || error;
		}
	}
};
